import { Injectable } from '@angular/core';

@Injectable({
   providedIn: 'root',
})

export class AuthService {
    public isLoggedIn;

    isLoginAutenticated(){
        const tabId = sessionStorage.getItem('tabId');
        const tokenKey = `authToken-${tabId}`;
        const token = localStorage.getItem(tokenKey);
        if (token) {
            return true;
        }
        else{
            return false;
        }
    }
}